import React from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { navItems } from '../utils/nav-config'; // ✅ make sure this path is correct

export default function Navbar({ setMenuOpen }) {
  const location = useLocation();

  const handleNavClick = (path) => {
    // Close mobile menu
    setMenuOpen(false);
    
    // If clicking the same page, scroll to top
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <ul className="navbar-nav">
      {navItems.map(({ path, label }) => (
        <li className="nav-item" key={path}>
          {label === "Let's Chat" ? (
            <NavLink
              to={path}
              end
              className={({ isActive }) => 'nav-link f-uc btn btn-sm px-2 py-1' + (isActive ? ' selected' : '')}
              style={{ fontSize: 13, lineHeight: 1.2 }}
              onClick={() => handleNavClick(path)}
            >
              {label}
            </NavLink>
          ) : (
            <Link
              to={path}
              className="nav-link f-uc"
              onClick={() => handleNavClick(path)}
            >
              {label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
}
